import React, { useState } from "react";
import PricingHeader from "../../../../../../components/Pricing/PricingHeader";
import { MdOutlineCreate, MdOutlineKeyboardArrowDown } from "react-icons/md";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { Form, Table } from "react-bootstrap";
import { MenuItem, OutlinedInput, Select } from "material-ui-core";
import { MenuProps } from "../../../../../../utility/data";
import { collectionData, priceData } from "../frame-products/left";

const Left = () => {
  const [tableData, setTableData] = useState([
    {
      id: 1,
      name: "Test 1",
      selectedCollection: "",
      selectedPricing: "",
    },
    {
      id: 2,
      name: "Astragal rectangular",
      selectedCollection: "",
      selectedPricing: "",
    },
    {
      id: 3,
      name: "Georgian rectangular",
      selectedCollection: "",
      selectedPricing: "",
    },
  ]);
  const [selectedPricing, setSelectedPricing] = useState();
  const [selectedSupplyOnly, setSelectedSupplyOnly] = useState("");
  const [costPrice, setCostPrice] = useState([]);

  const handleCollection = (e, id) => {
    const tempArray = [...tableData];
    tempArray?.forEach((item) => {
      if (item.id === id) {
        item.selectedCollection = e.target.value;
      }
    });
    setTableData(tempArray);
  };

  const handlePrice = (e, id) => {
    const tempArray = [...tableData];
    tempArray?.forEach((item) => {
      if (item.id === id) {
        item.selectedPricing = e.target.value;
      }
    });
    setTableData(tempArray);
  };

  return (
    <>
      <PricingHeader
        setSelectedSupplyOnly={setSelectedSupplyOnly}
        setSelectedPricing={setSelectedPricing}
        selectedPricing={selectedPricing}
        selectedSupplyOnly={selectedSupplyOnly}
        costPrice={costPrice}
      />
      <div className="d-flex align-items-center mb-4 flex-wrap gap-3 left_header">
        <h5 className="mb-0 text-wrap text-break me-4 main_title">
          Glazing Designs
        </h5>
        <Link to={{}}>
          <div className="ms-sm-3">
            <MdOutlineCreate className="text-primary me-1 mb-1" size={18} />
            <span className="text-primary d-none d-sm-inline-block">
              Customize
            </span>
          </div>
        </Link>
      </div>
      <Form className="h-100 d-flex flex-column flex-grow-1 justify-content-between">
        <div className="inside_scroll has_tab has_btns">
          <Table responsive className="w-100 discount_table">
            <thead className="border-bottom">
              <tr>
                <th style={{ width: "60%", minWidth: "60%" }}></th>
                <th style={{ width: "20%", minWidth: "20%" }}>Collection</th>
                <th
                  style={{ width: "20%", minWidth: "20%" }}
                  className="text-start"
                >
                  Price list
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((item, index) => (
                <tr key={index}>
                  <td style={{ width: "40%", minWidth: "40%" }}>{item.name}</td>
                  <td>
                    <Select
                      id={`${item.id}collection`}
                      displayEmpty
                      value={item.selectedCollection}
                      label={"GLideline"}
                      onChange={(e) => handleCollection(e, item.id)}
                      input={
                        <OutlinedInput
                          className="w-100"
                          name="collectionName"
                        />
                      }
                      MenuProps={MenuProps}
                      IconComponent={() => (
                        <MdOutlineKeyboardArrowDown
                          size={20}
                          className="me-1 MuiSvgIcon-root MuiSelect-icon"
                        />
                      )}
                    >
                      {collectionData.map((item) => (
                        <MenuItem key={item.id} value={item.title}>
                          {item.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </td>
                  <td>
                    <Select
                      id={`${item.id}price`}
                      displayEmpty
                      value={item.selectedPricing}
                      label={"Pricelist"}
                      onChange={(e) => handlePrice(e, item.id)}
                      input={
                        <OutlinedInput
                          className="w-100"
                          name="collectionName"
                        />
                      }
                      MenuProps={MenuProps}
                      IconComponent={() => (
                        <MdOutlineKeyboardArrowDown
                          size={20}
                          className="me-1 MuiSvgIcon-root MuiSelect-icon"
                        />
                      )}
                    >
                      {priceData.map((item) => (
                        <MenuItem key={item.id} value={item.title}>
                          {item.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="d-flex gap-2 gap-xl-3 main_buttons">
          <Button color="primary" size="md" className="px-4">
            Save Changes
          </Button>

          <Button color="primary" size="md" outline className="px-4">
            Reset
          </Button>
        </div>
      </Form>
    </>
  );
};

export default Left;
